module.exports = __webpack_public_path__ + "img/company-team-2.e2e104c1.jpg";